import { Injectable } from '@angular/core';
import { APIResponse } from '@mommy/models/Comm.model';
import { Api } from '@mommy/services/api';

@Injectable({
  providedIn: 'root',
})
export class MemberPostLikeService {
  constructor(private api: Api) {}

  add(post_id: number): Promise<any> {
    const endpoint = `v1/member/action-log/post-like`;

    return new Promise(async (resolve, reject) => {
      try {
        const params: any = {};
        params.object_id = post_id;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-like add error', error);
        reject(error);
      }
    });
  }

  remove(post_id: number): Promise<any> {
    const endpoint = `v1/member/action-log/post-like/remove`;

    return new Promise(async (resolve, reject) => {
      try {
        const params: any = {};
        params.object_id = post_id;

        const result: APIResponse = await (<any>(
          this.api.post(endpoint, params).toPromise()
        ));
        console.log('result', result);
        if (result.returnCode === 'ERROR') {
          reject(result);
        } else {
          resolve(result.data);
        }
      } catch (error) {
        console.error('member-post-like remove error', error);
        reject(error);
      }
    });
  }
}
